<template>
    <div class="Details">
        <h2>{{ data.ti }}</h2>
        <div v-show="url == 'duxiu/book'">
            <p>
                <span>作者</span>
                {{ data.au }}
            </p>
            <p>
                <span>页码</span>
                {{ data.pages }}
            </p>
            <p>
                <span>主题词</span>
                {{ data.zhutici }}
            </p>
            <p>
                <span>中图法分类号</span>
                {{ data.zhongtufa }}
            </p>
            <p>
                <span>内容提要</span>
                {{ data.ab }}
            </p>
            <p style="border-bottom:1px dashed;padding-bottom:0.5rem;margin-bottom:1rem;">
                <span>参考文献格式</span>
                {{ data.reference }}
            </p>
            <p v-show="link" style="margin-top:1.5rem;color:#666;font-size: 1rem;">
                全文链接:请复制到手机浏览器或电脑浏览器打开
                <span style="display:block;width:100%;text-align:center;"
                    ><a
                        href="javascript:;"
                        class="copybtn"
                        size="small"
                        plain
                        type="primary"
                        :data-clipboard-text="downY"
                        @click="copy()"
                        style="margin:0 10px 0 0"
                        ><img src="../assets/copy.png" alt=""/></a
                    >&lArr; 点击复制</span
                >
            </p>
            <van-button color="#0d60a2" @click="downloadPdf" v-show="pdfShow"> <img src="../publics/image/ck.png" alt="" /> 查看pdf </van-button>
        </div>
        <div v-show="url == 'sinomed'">
            <p>
                <!-- <span>作者</span> -->
                {{ data.au }}
            </p>
            <p>
                <!-- <span>作者单位:</span> -->
                作者单位: {{ data.affs }}
            </p>
            <p>
                <!-- <span>来源</span> -->
                来源: {{ data.so }}
            </p>
            <p>
                <!-- <span>学科分类号</span> -->
                {{ data.subjectType }}
            </p>
            <p>
                <!-- <span>ISSN</span> -->
                {{ data.issn }}
            </p>
            <p>
                <!-- <span>国内代码</span> -->
                {{ data.domesticCode }}
            </p>
            <p>
                <!-- <span>流水号</span> -->
                {{ data.streamNo }}
            </p>
            <p style="border-bottom:1px dashed;padding-bottom:0.5rem;margin-bottom:1rem;">
                <!-- <span style="width:2.3rem">摘要:</span> -->
                {{ data.ab }}
            </p>
            <p v-show="link" style="margin-top:1.5rem;color:#666;font-size: 1rem;">
                全文链接:请复制到手机浏览器或电脑浏览器打开
                <span style="display:block;width:100%;text-align:center;"
                    ><a
                        href="javascript:;"
                        class="copybtn"
                        size="small"
                        plain
                        type="primary"
                        :data-clipboard-text="downY"
                        @click="copy()"
                        style="margin:0 20px 0 0"
                        ><img src="../assets/copy.png" alt=""/></a
                    >&lArr; 点击复制</span
                >
            </p>
            <van-button color="#0d60a2" @click="downloadPdf" v-show="pdfShow"> <img src="../publics/image/ck.png" alt="" /> 查看pdf </van-button>
        </div>
        <van-popup v-model="showGetpdf" closeable :style="{ width: '100%', height: '100%' }">
            <div class="pdfDiv" ref="yourName">
                <img v-for="img in getPdf" :key="img.index" v-lazy="img" @click="showGetpdf = false" />
            </div>
            <van-pagination v-model="currentPage" :page-count="pageCount" mode="simple" @change="page" />
        </van-popup>
    </div>
</template>
<script>
import wx from "weixin-js-sdk";
import Vue from "vue";
import { Toast, Dialog } from "vant";
import Clipboard from "clipboard";

Vue.use(Toast);
export default {
    props: ["url"],
    data() {
        return {
            show: false,
            data: {},
            pdfShow: false,
            pdfUrl: "",
            imgUrl: "",
            text: "",
            Url: this.url,
            showGetpdf: false,
            getPdf: [],
            currentPage: 1,
            pageCount: 0,
            downY: "",
            downZ: "",
            link: false
        };
    },
    mounted() {
        if (sessionStorage.getItem("copyType") == 1) {
            this.link = true;
            this.downY = sessionStorage.getItem("downY");
        }
        var detail = "/detail";
        var data = { url: decodeURIComponent(this.$route.query.url.split("?token")[0]) };
        if (this.Url == "duxiu") {
            detail = "/bookdetail";
        }
        this.$get(this.Url + detail, data).then((response) => {
            sessionStorage.setItem("copyType", 0);
            if (/(Android)/i.test(navigator.userAgent)) {
                this.link = false;
                this.downY = "";
            }
            // const u = navigator.userAgent;
            // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            // if (isiOS) {
            //     return "ios";
            // } else {
            //     this.link = false;
            //     this.downY = "";
            // }

            if (response.data.downloadUrl != "" && response.data.downloadUrl != null) {
                this.pdfUrl = response.data.downloadUrl;
                this.pdfShow = true;
            } else {
                this.pdfShow = false;
            }

            this.data = response.data;
        });
    },
    methods: {
        downloadPdf() {
            if (this.Url == "duxiu/book") {
                this.currentPage = 1;
                this.duxiuPdf();
            } else {
                var pdfData = { url: decodeURIComponent(this.pdfUrl) };
                if (this.downY != "" && this.downY != "null") {
                    if (window.__wxjs_environment === "miniprogram") {
                        if (this.downY != "" && this.downY != null && this.downY != undefined) {
                            wx.miniProgram.navigateTo({
                                url: "../a/a?pdfUrl=" + this.downY
                            });
                        }
                        this.link = false;
                    } else {
                        window.location.href = this.downY;
                    }
                } else {
                    this.$get(this.Url + "/download", pdfData).then((response) => {
                        if (response.code == 3) {
                            Toast(response.msg);
                        } else {
                            if (new Date().getTime() - localStorage.getItem("time") >= 30 * 24 * 60 * 60 * 1000) {
                                Dialog.confirm({
                                    message: "将要打开pdf，您可以在预览后返回此界面复制链接进行分享或者在浏览器进行下载",
                                    confirmButtonText: "我知道了",
                                    cancelButtonText: "不再提示"
                                })
                                    .then(() => {
                                        this.dofun(response);
                                    })
                                    .catch(() => {
                                        // 不再提示
                                        this.dofun(response);
                                        localStorage.setItem("time", new Date().getTime());
                                    });
                            } else {
                                this.dofun(response);
                            }
                        }
                    });
                }
            }
        },

        dofun(res) {
            this.downY = res.data;
            this.link = true;
            var isWX = window.__wxjs_environment === "miniprogram";
            if (isWX) {
                if (res.data != "" && res.data != null && res.data != undefined) {
                    wx.miniProgram.navigateTo({
                        url: "../a/a?pdfUrl=" + res.data
                    });
                }
                // this.link = false;
            } else {
                sessionStorage.setItem("copyType", 1);
                sessionStorage.setItem("downY", this.downY);
                window.location.href = this.downY;
            }
        },

        duxiuPdf(page) {
            if (page >= 2) {
                this.$refs.yourName.scrollTop = 0;
            }
            this.$get("/duxiu/book/download", {
                detailUrl: decodeURIComponent(this.pdfUrl),
                page: page
            }).then((response) => {
                if (response.code == 3) {
                    Toast(response.msg);
                } else {
                    this.showGetpdf = true;
                    this.getPdf = response.data.list;
                    this.pageCount = parseInt(response.data.allsize / response.data.list.length);
                }
            });
        },
        page() {
            this.duxiuPdf(this.currentPage);
        },
        copy() {
            let clipboard = new Clipboard(".copybtn");
            clipboard.on("success", () => {
                Toast("复制成功");
                clipboard.destroy();
            });
            clipboard.on("error", () => {
                Toast("复制失败");
                clipboard.destroy();
            });
        }
    }
};
</script>
<style lang="less">
.Details {
    margin-top: 0.8rem;
    background: #fff;
    padding: 1rem;

    h2 {
        color: #0c60a3;
        margin-bottom: 0.8rem;
    }

    > p {
        color: #929292;
        padding-bottom: 1rem;
        border-bottom: 1px solid #f3f3f3;
    }

    div {
        p {
            margin-top: 0.5rem;
            line-height: 1.5rem;
            a {
                img {
                    width: 30px;
                    vertical-align: middle;
                }
            }
            span {
                width: 20%;
                display: inline-block;
            }
        }

        > button {
            width: 100%;
            font-size: 0.8rem;
            margin: 0.5rem 0 1rem;
            img {
                width: 1rem;
                vertical-align: -0.1rem;
                margin-right: 0.2rem;
            }
        }
    }

    .van-popup {
        width: 70%;
        img {
            width: 100%;
        }
        > div {
            padding: 2rem 1rem;
            overflow: hidden;
            .van-cell,
            img {
                border: 1px solid #dddddd;
                float: left;
                height: 46px;
                border-radius: 5px;
            }

            .van-cell {
                width: 60%;
            }

            img {
                width: 35%;
                margin-left: 0.7rem;
            }

            button {
                width: 100%;
                margin-top: 1rem;
            }
        }
    }

    .pdfDiv {
        width: 100%;
        height: 94%;
        overflow: auto !important;

        > img {
            width: 100% !important;
            height: 100% !important;
            margin-left: 0rem !important;
            border: 0 !important;
        }
    }
}
</style>
